export const UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_REQUEST = 'UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_REQUEST';

export const updateStatementTemplatePlaceholderRequest = ( id, updateData ) => ({
    type: UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_REQUEST,
    payload: {
        id,
        updateData
    }
});
